import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Aside from "../../components/Aside";
import Api from "../../services/api";
import swal from "sweetalert";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import EditSlide from "./edit";
import NewSlide from "./new";
import ReactTooltip from "react-tooltip";
import moment from "moment";

export default function Eventos() {
  const [loading, setLoading] = useState(true);
  const Loader = () => <div className="loading"></div>;
  const [eventos, setEventos] = useState([]);
  const [openModalNew, setOpenModalNew] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [eventosEdit, setEventosEdit] = useState([]);

  useEffect(() => {
    loadEventos();
  }, []);

  function loadEventos() {
    Api.get("/eventos/list")
      .then((response) => {
        setEventos(response.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
      });
  }

  function editSlide(evento) {
    setEventosEdit(evento);
    setOpenModalEdit(true);
  }

  function deleteSlide(evento) {
    swal({
      title: "Excluir Evento",
      text: "Deseja realmente excluir o evento '" + evento.nome_pt + "' ?",
      icon: "warning",
      html: true,
      buttons: ["Cancelar", "Excluir"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setLoading(true);
        Api.delete("/eventos/delete/" + evento.id)
          .then((response) => {
            swal(response.data.message, {
              icon: "success",
            });
            loadEventos();
            setLoading(false);
          })
          .catch((err) => {
            swal("ops! ocorreu um erro" + err, {
              icon: "success",
            });
            setLoading(false);
          });
      }
    });
  }

  const RenderContent = () => {
    useEffect(() => {
      ReactTooltip.rebuild();
    }, [eventos]); // Reconstrói os tooltips sempre que a lista de eventos for alterada

    return (
      <div className="table-container">
        <table className="custom-table">
          <thead>
            <tr>
              <th>Ações</th>
              <th>Nome</th>
              <th>Data</th>
            </tr>
          </thead>
          <tbody>
            {eventos.map((evento, index) => (
              <tr key={index}>
                <td>
                  <a
                    href="#"
                    onClick={() => editSlide(evento)}
                    data-tip="Editar"
                    data-for="tooltip-editar"
                  >
                    <i className="bx bx-edit"></i>
                  </a>
                  <Link
                    to={`eventos/${evento.id}/fotos`}
                    data-tip="Fotos"
                    data-for="tooltip-fotos"
                  >
                    <i className="bx bx-photo-album"></i>
                  </Link>
                  <a
                    href="#"
                    onClick={() => deleteSlide(evento)}
                    data-tip="Excluir"
                    data-for="tooltip-excluir"
                  >
                    <i className="bx bx-trash"></i>
                  </a>
                </td>
                <td>{evento.nome_pt}</td>
                <td>{moment(evento.data).format("DD/MM/YYYY")}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* ReactTooltip para tooltips globais */}
        <ReactTooltip id="tooltip-editar" effect="solid" />
        <ReactTooltip id="tooltip-fotos" effect="solid" />
        <ReactTooltip id="tooltip-excluir" effect="solid" />
      </div>
    );
  };

  function renderTopPage() {
    return (
      <div className="top">
        <div>
          <span className="text">Eventos</span>
          <ul className="breadcrumbs">
            <li>Eventos</li>
            <li>Listagem</li>
          </ul>
        </div>
        <div>
          <div className="actions top">
            <Link
              to="#"
              onClick={() => {
                setOpenModalNew(true);
              }}
            >
              <i className="bx bx-plus-circle"></i> Evento
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {loading ? <Loader /> : null}
      <ReactTooltip effect="solid" />
      <div className="container-box">
        <Aside />
        <main>
          {renderTopPage()}
          {eventos && RenderContent()}
        </main>

        <Modal
          open={openModalNew}
          onClose={() => {
            setOpenModalNew(false);
          }}
          classNames={{
            overlay: "customOverlay",
            modal: "customModal50",
          }}
        >
          <NewSlide
            loadEventos={loadEventos}
            setOpenModalNew={setOpenModalNew}
          />
        </Modal>

        <Modal
          open={openModalEdit}
          onClose={() => {
            setOpenModalEdit(false);
          }}
          classNames={{
            overlay: "customOverlay",
            modal: "customModal50",
          }}
        >
          <EditSlide
            data={eventosEdit}
            loadEventos={loadEventos}
            setOpenModalEdit={setOpenModalEdit}
          />
        </Modal>
      </div>
    </>
  );
}
